import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': 'Português',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'Cancelar',
  'smarthr-ui/AppHeader/school': 'Escola SmartHR',
  'smarthr-ui/AppHeader/help': 'Ajuda',
  'smarthr-ui/AppHeader/userSettings': 'Configurações pessoais',
  'smarthr-ui/AppHeader/releaseNotes': 'Notas de lançamento',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'Falha ao carregar as notas de lançamento.\nPor favor, tente novamente mais tarde.',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'Ver toda as notas de lançamento sobre a avaliação de desempenho',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'Apps',
  'smarthr-ui/AppHeader/MobileHeader/account': 'Conta',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'Abrir o menu',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'Fechar o menu',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': 'Todos os apps',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': 'Menu de administração',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': 'Últimas notas de lançamento',
  'smarthr-ui/AppHeader/MobileHeader/back': 'Voltar',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': 'Abrir',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': 'Fechar',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'Insira o nome do app.',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'Apps favoritos',
  'smarthr-ui/AppHeader/Launcher/allModeText': 'Todos os apps',
  'smarthr-ui/AppHeader/Launcher/listText': 'Lista de apps',
  'smarthr-ui/AppHeader/Launcher/helpText': 'Sobre os apps favoritos',
  'smarthr-ui/AppHeader/Launcher/searchResultText': 'Resultados da pesquisa',
  'smarthr-ui/AppHeader/Launcher/emptyText': 'App não encontrado.',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': 'Ordenar por',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': 'Selecionando',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': 'Ordem padrão',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'Nome do app (A→Z)',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'Nome do app (Z→A)',
  'smarthr-ui/AppLauncher/showAllText': 'Ver tudo',
  'smarthr-ui/AppLauncher/triggerLabel': 'Apps',
  'smarthr-ui/Browser/notFoundDescription': 'Tente filtrar com outro critério.',
  'smarthr-ui/Browser/notFoundTitle': 'Nenhum item encontrado.',
  'smarthr-ui/Button/loading': 'Processando',
  'smarthr-ui/Calendar/currentYear': 'Ano atual',
  'smarthr-ui/Calendar/nextMonth': 'Mês seguinte',
  'smarthr-ui/Calendar/previousMonth': 'Mês anterior',
  'smarthr-ui/Calendar/selectYear': 'Selecione o ano',
  'smarthr-ui/Combobox/addItemButtonLabel': 'Acrescentar “{name}”',
  'smarthr-ui/Combobox/loadingText': 'Processando',
  'smarthr-ui/Combobox/noResultsText': 'Nenhum resultado correspondente encontrado.',
  'smarthr-ui/DropdownMenuButton/triggerActive': 'Fechar opções',
  'smarthr-ui/DropdownMenuButton/triggerInactive': 'Abrir opções',
  'smarthr-ui/DropZone/selectButtonLabel': 'Selecionar arquivo para upload',
  'smarthr-ui/FileViewer/rotateAlt': 'Girar para esquerda',
  'smarthr-ui/FileViewer/scaleDownAlt': 'Reduzir',
  'smarthr-ui/FileViewer/scaleRateLabel': 'Escala de ampliação (%)',
  'smarthr-ui/FileViewer/scaleUpAlt': 'Ampliar',
  'smarthr-ui/FileViewer/unsupportedFileText': 'Tipo de arquivo não compatível.',
  'smarthr-ui/FilterDropdown/applyText': 'Aplicar',
  'smarthr-ui/FilterDropdown/cancelText': 'Cancelar',
  'smarthr-ui/FilterDropdown/resetText': 'Limpar filtros',
  'smarthr-ui/FilterDropdown/status': 'Filtros aplicados',
  'smarthr-ui/FilterDropdown/triggerText': 'Filtrar',
  'smarthr-ui/FormDialog/closeButtonLabel': 'Cancelar',
  'smarthr-ui/InformationPanel/closeButtonLabel': 'Fechar',
  'smarthr-ui/InformationPanel/openButtonLabel': 'Abrir',
  'smarthr-ui/InputFile/destroy': 'Apagar',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': 'Selecionando',
  'smarthr-ui/Loader/alt': 'Processando',
  'smarthr-ui/MessageDialog/closeButtonLabel': 'Fechar',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': 'Fechar',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'Posição do diálogo',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'Possível arrastar',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': 'Possível mover na horizontal e na vertical pressionando as teclas de seta',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '{top} px da parte de cima, {left} px da parte de baixo',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': ': apagar',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': 'Itens selecionados',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': 'Fechar',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': 'Primeiro',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': 'Último',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': 'Próximo',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': 'Anterior',
  'smarthr-ui/Pagination/itemButtonLabel': 'Página {page}',
  'smarthr-ui/Pagination/navigationLabel': 'Paginação',
  'smarthr-ui/RequiredLabel/text': 'Obrigatório',
  'smarthr-ui/SearchInput/iconAlt': 'Pesquisar',
  'smarthr-ui/SideMenu/navigationLabel': 'Menu lateral',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'Limpar',
  'smarthr-ui/SortDropdown/applyText': 'Aplicar',
  'smarthr-ui/SortDropdown/ascLabel': 'Crescente',
  'smarthr-ui/SortDropdown/cancelText': 'Cancelar',
  'smarthr-ui/SortDropdown/descLabel': 'Decrescente',
  'smarthr-ui/SortDropdown/sortFieldLabel': 'Itens para ordenação',
  'smarthr-ui/SortDropdown/sortOrderLegend': 'Ordenação',
  'smarthr-ui/StepFormDialog/backButtonLabel': 'Voltar',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'Cancelar',
  'smarthr-ui/StepFormDialog/nextButtonLabel': 'Próximo',
  'smarthr-ui/StepStatusIcon/closedAlt': 'Interrompido',
  'smarthr-ui/StepStatusIcon/completedAlt': 'Concluído',
  'smarthr-ui/Textarea/availableLetters': '{availableLetters} caracteres restantes',
  'smarthr-ui/Textarea/maxLettersExceeded': '{exceededLetters} caracteres excedidos',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': '{maxLetters} caracteres no máximo',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': 'Abra em outra guia',
  'smarthr-ui/Th/sortDirectionAsc': 'Crescente',
  'smarthr-ui/Th/sortDirectionDesc': 'Decrescente',
  'smarthr-ui/Th/sortDirectionNone': 'Sem ordenação',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'Selecionar/limpar tudo',
  'smarthr-ui/ThCheckbox/checkColumnName': 'Selecionar',
} as const satisfies Record<keyof typeof ja, string>
